import { useEffect, useState } from "react";
import {
  Button,
  Tooltip,
  TextField,
  Box,
  Stack,
  Grid,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { styled, alpha } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { policiesAction } from "../../../const/policies";
import { checkPolicy } from "../../../functions/checkPolicy";
import { changeViewState } from "../../../redux/reducers/changeView-reducer";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import MobileScreenShareIcon from "@mui/icons-material/MobileScreenShare";
import DesktopWindowsIcon from "@mui/icons-material/DesktopWindows";
import useBackPathFromUrl from "../../../Hooks/useBackfromUrlPath";
import OverrideMaxWidth from "../../../functions/overrideMaxWidth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faBan, faMagnifyingGlass, faMap, faPlus, faRotateRight } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
let buttonViewMap = false;

const paddingSideMobile = 33;
const paddingSideDesktop = 130;

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: "auto",
  color: "#3e6bb4",
}));

const TableToolbar = ({
  startSearch,
  customButton = undefined,
  initialSearchText,
  enableSearch,
  enableBackOnToolbar = false,
  isSalaRiunione = true,
  showResetDisable,
  downloadXLS,
  enableExport,
  handleAdd,
  enableAdd,
  typePage,
  enableDisable,
  disableAction,
  mobile = true,
  map = false,
  changeViewToMap,
}) => {
  const statePolicy = useSelector((state) => state.userDate.policies);
  const dispatch = useDispatch();
  const userDate = useSelector((state) => state.userDate);
  const [searchText, setSearchText] = useState(initialSearchText);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
  const { t } = useTranslation();
  const [delta, setDelta] = useState(
    window.innerWidth > 600 ? paddingSideDesktop : paddingSideMobile
  );
  const [width, setWidth] = useState(window.innerWidth);
  const viewState = useSelector((state) => state.viewState);
  const navigate = useNavigate();

  const { policies: statePolicies, responsabileEdificio } = userDate;

  const handleResizeWindow = () => {
    setWidth(window.innerWidth);
    if (window.innerWidth > 600) {
      setDelta(paddingSideDesktop);
      setIsMobile(false);
    } else {
      setDelta(paddingSideMobile);
      setIsMobile(true);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResizeWindow);
    return () => {
      window.removeEventListener("resize", handleResizeWindow);
    };
  });

  function changeViewMap() {
    buttonViewMap = changeViewToMap();
  }

  useEffect(() => {
    if (map) {
      //da un problema sul render se si toglie mobile
      buttonViewMap =
        typePage === "planimetriaGestione" || (mobile && buttonViewMap)
          ? true
          : false;
      if (mobile && buttonViewMap) {
        changeViewMap();
      }
    } else {
      buttonViewMap = false;
    }
  }, []);

  const path = useBackPathFromUrl();

  let string = OverrideMaxWidth(width, delta);

  return (
    //<GridToolbarContainer className={gridClasses.toolbarContainer}>
    <Grid container rowSpacing={2}>
      <Grid
        item
        xs={12}
        sm={12}
        md={9}
        lg={9}
        sx={{ overflow: "auto", maxWidth: string }}
      >
        <Stack direction="row">
          {path != "" && enableBackOnToolbar && (
            <div className="buttonBoxToolbar">
              <Tooltip title={t("back")}>
                <Button
                  variant="outlined"
                  startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
                  size="small"
                  sx={{ color: "#3e6bb4" }}
                  onClick={() => navigate(path)}
                >
                  {t("back")}
                </Button>
              </Tooltip>
            </div>
          )}
          {enableExport &&
            checkPolicy(statePolicy, policiesAction.esportazione, typePage) && (
              <div className={t("enableExport")}>
                <Tooltip title="Download file Excel">
                  <Button
                    variant="outlined"
                    startIcon={<DownloadIcon />}
                    size="small"
                    sx={{ color: "#3e6bb4" }}
                    onClick={downloadXLS}
                  >
                    {t("enableExport")}
                  </Button>
                </Tooltip>
              </div>
            )}
          {!isMobile && mobile && (
            <div className="buttonBoxToolbar">
                <Tooltip
                  title={viewState ? t("desktopMode") : t("mobileMode")}
                >
                <Button
                  variant="outlined"
                  startIcon={
                    viewState ? (
                      <DesktopWindowsIcon fontSize="large" color="primary" />
                    ) : (
                      <MobileScreenShareIcon fontSize="large" color="primary" />
                    )
                  }
                  size="small"
                  sx={{ color: "#3e6bb4" }}
                  onClick={() => dispatch(changeViewState())}
                >
                  {viewState ? "Desktop" : "Mobile"}
                </Button>
              </Tooltip>
            </div>
          )}
          {map && !viewState && (
            <Tooltip title={t("floorPlan")}>
              <div className="buttonBoxToolbar">
                <Button
                  variant="outlined"
                  startIcon={<FontAwesomeIcon icon={faMap} className="pathIcon" />}
                  size="small"
                  sx={{ color: "#3e6bb4" }}
                  onClick={() => changeViewMap()}
                >
                  {buttonViewMap ? t("list") : t("floorPlan")}
                </Button>
              </div>
            </Tooltip>
          )}
          {!isSalaRiunione &&
            enableAdd &&
            checkPolicy(
              statePolicy,
              policiesAction.inserimentoModifica,
              typePage
            ) && (
              <Tooltip title={t("Handle_Add")}>
                <div className="buttonBoxToolbar">
                  <Button
                    variant="outlined"
                    startIcon={<FontAwesomeIcon icon={faPlus} />}
                    size="small"
                    sx={{ color: "#3e6bb4" }}
                    onClick={handleAdd}
                  >
                    {t("Handle_Add")}
                  </Button>
                </div>
              </Tooltip>
            )}
            {customButton && customButton}
          {enableDisable &&
            (checkPolicy(
              statePolicy,
              policiesAction.abilitaDisabilita,
              typePage
            ) ||
              responsabileEdificio.length > 0) && (
              <Tooltip title={t("disable_Action")}>
                <div className="buttonBoxToolbar">
                  <Button
                    variant="outlined"
                    startIcon={<FontAwesomeIcon icon={faBan} />}
                    size="small"
                    sx={{ color: "#3e6bb4" }}
                    onClick={() => disableAction("disableRangeData")}
                  >
                    {t("disable_Action")}
                  </Button>
                </div>
              </Tooltip>
            )}
          {showResetDisable &&
            enableDisable &&
            (checkPolicy(
              statePolicy,
              policiesAction.abilitaDisabilita,
              typePage
            ) ||
              responsabileEdificio.length > 0) && (
              <Tooltip title={t("enable")}>
                <div
                  style={{ marginRight: "15px" }}
                  className="buttonBoxToolbar"
                >
                  <Button
                    variant="outlined"
                    startIcon={<FontAwesomeIcon icon={faRotateRight} />}
                    size="small"
                    sx={{ color: "#3e6bb4" }}
                    onClick={() => disableAction("ripristinaAll")}
                  >
                    {t("enable")}
                  </Button>
                </div>
              </Tooltip>
            )}
        </Stack>
      </Grid>
      <Grid item xs={12} sm={12} md={3} lg={3}>
        {enableSearch && (
          <Search className="no-margin-right">
            <Box sx={{ display: "flex", alignItems: "flex-end" }}>
              <TextField
                id="search-input"
                placeholder={t("search...")}
                inputProps={{ "aria-label": "search" }}
                value={searchText}
                variant="standard"
                fullWidth
                onChange={(event) => {
                  setSearchText(event.target.value);
                }}
                onBlur={() => {
                  startSearch(searchText);
                }}
                onKeyPress={(event) => {
                  if (event.key === "Enter") {
                    startSearch(searchText);
                  }
                }}
              />
              <Tooltip title={t("search")}>
                <Button
                  variant="outlined"
                  sx={{
                    borderRadius: "500px",
                    padding: "0",
                    minHeight: "35px",
                    minWidth: "35px",
                  }}
                  onClick={() => {
                    startSearch(searchText);
                  }}
                >
                  <FontAwesomeIcon icon={faMagnifyingGlass} style={{ marginRight: 0, margin: 0 }} />
                </Button>
              </Tooltip>
            </Box>
          </Search>
        )}
      </Grid>
    </Grid>
    //</GridToolbarContainer>
  );
};

export default TableToolbar;
